
<template>
  <div id="homeDesktop">
    <div id="navigation">
      <div style="position: relative;">
        <Navigation />

      </div>
    </div>
    <div id="banner">
      <p id="textBanner">Lieferung in 8 Wochen - 10% Preisnachlass bei mehreren Bestellungen</p>
    </div>


    <div id="A_intro">
      <div style="position: relative;">
        <!-- <div id="introChips">
          <v-card class="mx-auto cardWrapper" color="var(--accentColorShaded)" >
            <div class="cardIntro">
              <img src="./../../public/icons/treePlanting.svg" style="position: relative; left: 0; bottom: 7px;" height="60px"/>
              <h3 style="color: var(--mainColor)">{{getBullet.bulletpoints[0]}}</h3>
            </div>
          </v-card>
          <v-card class="mx-auto cardWrapper" color="var(--accentColorShaded)" >
            <div class="card">
              <img src="./../../public/icons/upcycling.svg" style="position: relative; left: 0; bottom: 7px;" height="60px"/>
              <h3 style="color: var(--mainColor)">{{getBullet.bulletpoints[1]}}</h3>
            </div>
          </v-card>
        </div> -->
      </div>
      <div style="position: relative;">
        <div id="introTextView">
            <h1 style="font-size: 2em !important;">
              {{getText.intro.title1}} {{getText.intro.title2}}
            </h1>
            <p>
              <br />
              {{getText.intro.subTitle1}}
              <br />
              {{getText.intro.subTitle2}}
              <br />
              {{getText.intro.subTitle3}}
            </p>
            <router-link to="/configuratorDesktop">
              <v-btn @click="configButtonMain1" class="ma-2" color="var(--accentColor)" style="margin: 0 !important;">
                <span style="color:var(--mainColor);">{{getText.intro.link}}</span>
              </v-btn>
            </router-link>
        </div>
        <!-- <div id="introChips">
          <v-card class="mx-auto cardWrapper" color="var(--accentColorShaded)" >
            <div class="card">
              <img src="./../../public/icons/plankIndividual.svg" style="position: relative; left: 0; bottom: 7px;" height="60px"/>
              <h3 style="color: var(--mainColor)">{{getBullet.bulletpoints[2]}}</h3>
            </div>
          </v-card>
          <v-card class="mx-auto cardWrapper" color="var(--accentColorShaded)" >
            <div class="card">
              <img src="./../../public/icons/berlin.svg" style="position: relative; left: 0; bottom: 7px;" height="60px"/>
              <h3 style="color: var(--mainColor)">{{getBullet.bulletpoints[4]}}</h3>
            </div>
          </v-card>
        </div> -->
      </div>
    </div>

    <div id="introChips">
      <div class="introChip">
        <v-card class="mx-auto cardWrapper" color="var(--accentColorShaded)" >
          <div class="cardIntro">
            <img src="./../../public/icons/upcycling.svg" style="position: relative; left: 0; bottom: 7px;" height="60px"/>
            <h3 style="color: var(--mainColor)">{{getBullet.bulletpoints[1]}}</h3>
          </div>
        </v-card>
      </div>
      <div class="introChip">
        <v-card class="mx-auto cardWrapper" color="var(--accentColorShaded)" >
          <div class="cardIntro">
            <img src="./../../public/icons/plankIndividual.svg" style="position: relative; left: 0; bottom: 7px;" height="60px"/>
            <h3 style="color: var(--mainColor)">{{getBullet.bulletpoints[2]}}</h3>
          </div>
        </v-card>
      </div>
      <div class="introChip">
        <v-card class="mx-auto cardWrapper" color="var(--accentColorShaded)" >
          <div class="cardIntro">
            <img src="./../../public/icons/berlin.svg" style="position: relative; left: 0; bottom: 7px;" height="60px"/>
            <h3 style="color: var(--mainColor)">{{getBullet.bulletpoints[4]}}</h3>
          </div>
        </v-card>
      </div>
    </div>

    <div id="B_material">
      <!-- <v-card class="mx-auto cardWrapper" color="var(--accentColorShaded)" style="margin-bottom: 60px;">
        <div class="card">
          <img src="./../../public/icons/delivery.svg" style="position: relative; left: 15px; bottom: 20px;" height="60px"/>
          <h3 style="color: var(--mainColor)">{{getText.intro.delivery}}</h3>
        </div>
      </v-card> -->

      <div id="b_plankPictureView" style="position: relative;" class="fullWidthElement">
        <img src="./../../public/img/gerüstbohle-d.jpeg" alt="gerüstbohle" width="100%" height="200px" style="position: relative;"/>
        <div style="position: absolute; top: 20px; left: 0; right: 0; margin: auto;width: 700px;">
          <!-- <div style="background-color: var(--accentColorShaded); border-radius: 4px;"> -->
            <!-- <div v-observe-visibility="(isVisible) => visibilityChanged(isVisible, 'numbersPlanksHome')">
              <img src="./../../public/icons/upcycling.svg" style="position: relative; left: 0; bottom: 15px;" height="180px"/>
            </div> -->
            <!-- <p style="padding: 0 5px;">
              {{getText.material.text1}}
              <br />
              {{getText.material.text2}}
            </p> -->
          <!-- </div> -->
        </div>
      </div>

      <div class="slideGroup" style="margin-top: 60px;">
        <div></div>
        <div>
          <v-slide-group
            v-model="model"
            class="pa-4"
            active-class="success"
          >
            <v-slide-item>
                <v-card
                  class="ma-4"
                  elevation="4"
                  height="500"
                  width="300"
                  style="position: relative;"
                >
                  <v-img
                    class="white--text align-end"
                    height="300px"
                    src="./../../public/img/rho-17-3d-konfigurator.jpeg"
                  >
                    <v-card-title>Online konfigurieren</v-card-title>
                  </v-img>
                  <v-card-text class="text--primary">
                    <div>Esstisch, Schreibtisch, Bank oder Regal - mit unserem Konfigurator kannst du dir ganz einfach Möbel mit deinen Wunschmaßen erstellen. Wähle hier individuell Maße, Gestell und Gerüstbohlen bequem in 3D.</div>
                  </v-card-text>
                </v-card>
            </v-slide-item>
            <v-slide-item>
                <v-card
                  color="white"
                  class="ma-4"
                  elevation="4"
                  height="500"
                  width="300"
                >
                <v-img
                  class="white--text align-end"
                  height="300px"
                  src="./../../public/img/rho-17-werkstatt.jpeg"
                >
                  <v-card-title>Upcycling nach 15 Jahren</v-card-title>
                </v-img>
                <v-card-text class="text--primary">
                  <div>Wir schonen Ressourcen und benutzen kein neues Holz für unsere Möbel, sondern schenken ausgedienten Holzbohlen aus dem Gerüstbau ein neues Leben. Nach ca. 15 Jahren im Einsatz als Baugerüst erzählt jede Gerüstbohle ihre eigene Geschichte.</div>
                </v-card-text>
                </v-card>
            </v-slide-item>
            <v-slide-item>
                <v-card
                  color="white"
                  class="ma-4"
                  elevation="4"
                  height="500"
                  width="300"
                >
                <v-img
                  class="white--text align-end"
                  height="300px"
                  src="./../../public/img/gerüstbohlen-bank-konfigurator.jpeg"
                >
                  <v-card-title>Zeitloses Design</v-card-title>
                </v-img>
                <v-card-text class="text--primary">
                  <div>Die Möbel die unsere Werkstatt verlassen sind aussergewöhlnich. Ihre minimalistische Ausstrahlung überdauert Trends und jedes Unikat ist liebevoll nach Kundenwunsch hergestellt. So sorgen wir dafür, dass unsere Produkte nach dem Upcycling noch lange wertgeschätzt werden.</div>
                </v-card-text>
                </v-card>
            </v-slide-item>
          </v-slide-group>
        </div>
        <div></div>
      </div>



      <!-- <div id="b_recycletext" class="centerElement">
        <div>
        </div>
        <div>
          <h1>
            {{numbersPlanksHome.counter}} {{getText.material.title}}
          </h1>
          <p style="padding: 0 5px;">
            {{getText.material.text1}}
            <br />
            {{getText.material.text2}}
          </p>
        </div>
        <div>
        </div>
      </div> -->

    </div>

    <div id="imageFilm" style="margin-bottom: 100px;">
      <youtube :video-id="videoId" :player-vars="playerVars" @playing="playing" width="1018" resize="true" height="572"></youtube>
    </div>

    <div id="C_tableConfigurator" class="leftRightElement slideELement" style="top: 6px;">
      <div style="position:relative;">
        <div class="stickyAnimation">
            <img src="./../../public/img/gerüstbohlen-möbel-konfigurieren.jpeg" alt="gerüstbohlen tisch, regal und hocker möbel" width="100%" style="object-fit: cover;"/>
        </div>
      </div>
      <div style="margin-bottom: 150px;">
        <div class="text">
          <h1>
            <span class="mediumLineHeight" style="text-align: left;">{{getText.furnitureConfigurator.title}}</span>
          </h1>
          <h3 style="text-align: left;">
            <span v-for="(text, i) in getText.furnitureConfigurator.text"  :key="i" class="mediumLineHeight" style="text-align: left;">{{text}}</span>
          </h3>
        </div>
        <router-link to="/configuratorDesktop">
          <v-btn @click="configButtonMain2" class="ma-2" color="var(--accentColor)">
            <span style="color:var(--mainColor);">{{getText.furnitureConfigurator.link}}</span>
          </v-btn>
        </router-link>
      </div>
    </div>

    <div id="D_sustainability" class="accentColorShadedBackground" style="padding: 100px 0;">
      <div class="centerElement" >
        <div>
        </div>
        <div>
          <h1>
            <span class="mediumLineHeight" style="text-align: left;">{{getText.design.title}}</span>
          </h1>
          <p>
            {{getText.design.text1}}
            <br />
            {{getText.design.text2}}
          </p>
        </div>
        <div>
        </div>
      </div>
      <div class="slideGroup">
        <div></div>
        <div>
          <v-slide-group
            v-model="model"
            class="pa-4"
            active-class="success"
            show-arrows
          >
            <v-slide-item>
                <v-card

                  class="ma-4"
                  elevation="4"
                  height="400"
                  width="300"
                  style="position: relative;"
                >
                  <v-img
                    class="white--text align-end"
                    height="200px"
                    src="./../../public/img/gerüstbohlen-tisch-konfigurator.jpeg"
                  >
                    <v-card-title>Tisch</v-card-title>
                  </v-img>
                  <v-card-text class="text--primary">
                    <div>Ob Schreibtisch, Esstisch oder Küchentisch - mit unserem Konfigurator</div>
                    <div>kannst du dir ganz einfach einen Tisch mit deinen Wunschmaßen erstellen.</div>
                  </v-card-text>
                  <div style="position: absolute; width: 100%; height: 100%; left: 0; top: 0;">
                    <div style="position: absolute; bottom: 20px; width: 100%;">
                      <router-link to="/configuratorTableDesktop" style="margin: auto;">
                        <v-btn
                          color="var(--mainColor)"
                          text
                          class="justify-center align-center"
                        >
                          Tisch konfigurieren
                        </v-btn>
                      </router-link>
                    </div>
                  </div>
                </v-card>
            </v-slide-item>
            <v-slide-item>
                <v-card
                  color="white"
                  class="ma-4"
                  elevation="4"
                  height="400"
                  width="300"
                >
                <v-img
                  class="white--text align-end"
                  height="200px"
                  src="./../../public/img/gerüstbohlen-bank-konfigurator.jpeg"
                >
                  <v-card-title>Bank</v-card-title>
                </v-img>
                <v-card-text class="text--primary">
                  <div>Unsere Bänke lassen sich mit anderen Möbelstücken gut kombinieren. Und auch einzeln als Sitzgelegenheit im Flur machen sich die Gerüstbohlenbänke super.</div>
                </v-card-text>
                  <div style="position: absolute; width: 100%; height: 100%; left: 0; top: 0;">
                    <div style="position: absolute; bottom: 20px; width: 100%;">
                      <router-link to="/configuratorBenchDesktop" style="margin: auto;">
                        <v-btn
                          color="var(--mainColor)"
                          text
                          class="justify-center align-center"
                        >
                          Bank konfigurieren
                        </v-btn>
                      </router-link>
                    </div>
                  </div>
                </v-card>
            </v-slide-item>
            <v-slide-item>
                <v-card
                  color="white"
                  class="ma-4"
                  elevation="4"
                  height="400"
                  width="300"
                >
                <v-img
                  class="white--text align-end"
                  height="200px"
                  src="./../../public/img/gerüstbohlen-hocker-konfigurator.jpeg"
                >
                  <v-card-title>Hocker</v-card-title>
                </v-img>
                <v-card-text class="text--primary">
                  <div>Unsere Hocker passen optisch nicht nur fantastisch zu den rho 17 Tischen, sondern lassen sich auch mit anderen Möbelstücken gut kombinieren.</div>
                </v-card-text>
                  <div style="position: absolute; width: 100%; height: 100%; left: 0; top: 0;">
                    <div style="position: absolute; bottom: 20px; width: 100%;">
                      <router-link to="/configuratorStoolDesktop" style="margin: auto;">
                        <v-btn
                          color="var(--mainColor)"
                          text
                          class="justify-center align-center"
                        >
                          Hocker konfigurieren
                        </v-btn>
                      </router-link>
                    </div>
                  </div>
                </v-card>
            </v-slide-item>
            <!-- <v-slide-item>
                <v-card
                  color="white"
                  class="ma-4"
                  elevation="4"
                  height="400"
                  width="300"
                >
                <v-img
                  class="white--text align-end"
                  height="200px"
                  src="./../../public/img/gerüstbohlen-regal-konfigurator.jpeg"
                >
                  <v-card-title>Regal</v-card-title>
                </v-img>
                <v-card-text class="text--primary">
                  <div>Das rho 17 Regal - der Neuzugang in der rho-Familie</div>
                </v-card-text>
                  <div style="position: absolute; width: 100%; height: 100%; left: 0; top: 0;">
                    <div style="position: absolute; bottom: 20px; width: 100%;">
                      <router-link to="/configuratorShelfDesktop" style="margin: auto;">
                        <v-btn
                          color="var(--mainColor)"
                          text
                          class="justify-center align-center"
                        >
                          Regal konfigurieren
                        </v-btn>
                      </router-link>
                    </div>
                  </div>
                </v-card>
            </v-slide-item> -->
            <!-- <v-slide-item>
                <v-card
                  color="white"
                  class="ma-4"
                  elevation="4"
                  height="400"
                  width="300"
                >
                <v-img
                  class="white--text align-end"
                  height="200px"
                  src="./../../public/img/gerüstbohlen-tischOffice-konfigurator.jpeg"
                >
                  <v-card-title>Schreibtisch</v-card-title>
                </v-img>
                <v-card-text class="text--primary">
                  <div>Der höhenverstellbare Schreibtisch von rho 17 zeichnet sich durch seine einzigartige, nachhaltige Arbeitsfläche aus.</div>
                </v-card-text>
                  <div style="position: absolute; width: 100%; height: 100%; left: 0; top: 0;">
                    <div style="position: absolute; bottom: 20px; width: 100%;">
                      <router-link to="/configuratorTableOfficeDesktop" style="margin: auto;">
                        <v-btn
                          color="var(--mainColor)"
                          text
                          class="justify-center align-center"
                        >
                          Schreibtisch konfigurieren
                        </v-btn>
                      </router-link>
                    </div>
                  </div>
                </v-card>
            </v-slide-item>
            <v-slide-item>
                <v-card
                  color="white"
                  class="ma-4"
                  elevation="4"
                  height="400"
                  width="300"
                >
                <v-img
                  class="white--text align-end"
                  height="200px"
                  src="./../../public/img/gerüstbohlen-rahmen-konfigurator.jpeg"
                >
                  <v-card-title>Rahmen</v-card-title>
                </v-img>
                <v-card-text class="text--primary">
                  <div>Du bist noch auf der Suche nach einem passenden Deko-Objekt zu deinen neuen Möbeln?</div>
                </v-card-text>
                  <div style="position: absolute; width: 100%; height: 100%; left: 0; top: 0;">
                    <div style="position: absolute; bottom: 20px; width: 100%;">
                      <router-link to="/configuratorFrameDesktop" style="margin: auto;">
                        <v-btn
                          color="var(--mainColor)"
                          text
                          class="justify-center align-center"
                        >
                          Rahmen konfigurieren
                        </v-btn>
                      </router-link>
                    </div>
                  </div>
                </v-card>
            </v-slide-item> -->
          </v-slide-group>
        </div>
        <div></div>
      </div>
    </div>

    <div id="E_benchConfigurator" class="leftRightElement slideELement">
      <div  style="margin-bottom: 150px;">
        <div class="text" style="text-align: right;">
          <h1>
            <span class="mediumLineHeight">{{getText.tableConfigurator.title}}</span>
          </h1>
          <h3>
            <span v-for="(text, i) in getText.tableConfigurator.text"  :key="i" class="mediumLineHeight">{{text}}</span>
          </h3>
        </div>
        <router-link to="/configuratorDesktop">
          <v-btn @click="configButtonMain3" class="ma-2" color="var(--accentColor)">
            <span style="color:var(--mainColor);">{{getText.tableConfigurator.link}}</span>
          </v-btn>
        </router-link>
      </div>
      <div style="position:relative;">
        <div class="stickyAnimation" >
            <img src="./../../public/img/gerüstbohlen-tisch-konfigurieren-m02.jpeg" alt="gerüstbohlen tisch" width="100%" style="object-fit: cover;"/>
        </div>
      </div>
    </div>

    <GetSample />

    <h1 style="margin-top: 150px;">{{getText.instagram}}</h1>
    <InstagramFeed />

    <div id="F_about" class="centerElement accentColorShadedBackground" style="padding: 100px 0; position: relative; top: -6px;">
      <div>
      </div>
      <div>
        <h1>
          <span class="mediumLineHeight">{{getText.about.title}}</span>
        </h1>
        <p>
          {{getText.about.text}}
        </p>
        <router-link to="/about">
          <v-btn @click="aboutUs" class="ma-2" color="var(--accentColor)">
            <span style="color:var(--mainColor);">{{getText.about.link}}</span>
          </v-btn>
        </router-link>
      </div>
      <div>
      </div>
    </div>

    <!-- <div style="max-width: 1000px; margin: auto; margin-bottom: 150px;" class="powr-instagram-feed" id="2c1afe03_1617280983"></div>
    <script type="application/javascript" src="https://www.powr.io/powr.js?platform=vuejs"></script> -->

    <div id="G_footer">
      <!-- <h2>{{getText.footer.title}}</h2>
        <a href="tel:004915154332276" style="text-decoration: none !important;">
          <div class="text-center" >
            <v-btn class="ma-2" color="var(--accentColor)"><span style="color:var(--mainColor);">0151 5433 2276</span></v-btn>
          </div>
        </a>
        <a href="mailto:info@rho-17.de?subject=Hallo,%20ich%20habe%20eine%20Frage" style="text-decoration: none !important;">
          <div class="text-center">
            <v-btn class="ma-2" color="var(--accentColor)"><span style="color:var(--mainColor);">{{getText.footer.mail}}</span></v-btn>
          </div>
        </a> -->

      <Footer />
    </div>

  </div>
</template>

<script>
import Navigation from '@/components/Navigation.vue'
import InstagramFeed from '@/components/InstagramFeed.vue'
import Footer from '@/components/Footer.vue'
import GetSample from '@/components/GetSample.vue'

export default {
  name: 'HomeDesktop',
  components: {
    Navigation,
    GetSample,
    InstagramFeed,
    Footer
  },
  data() {
    return{
      model: null,
      visibleElement: {
        numbersPlanksHome: false,
        numbersTreesHome: false,
        configurator:false,
        sales:false,
        about:false},
        interval: {},
        numbersPlanksHome: {activated: false, counter: 0},
        numbersTreesHome: {activated: false, counter: 0},
        videoId: 'zt7AqbuK7VM',
        // videoId: '2NjdK5PU7Ws',
        playerVars: {
          autoplay: 0
        }
    }
   },
   computed: {
     getSustainabilityNumbers() {
       return this.$store.getters.getSustainabilityNumbers;
     },
     getText(){
       return this.$store.getters.getText.main;
     },
     getBullet(){
       return this.$store.getters.getText.tableConfigurator
     }
   },
   mounted (){
     this.$store.dispatch("setNavbarActive", 0);
     window.scrollTo(0, 0)
   },
   methods: {
       configButtonMain1(){
       },
       configButtonMain2(){
       },
       configButtonMain3(){
       },
       plantMyTree(){
       },

       aboutUs(){
       },
     visibilityChanged (isVisible, element) {
       this.visibleElement[element] = isVisible
       if(!this.numbersPlanksHome.activated && element == 'numbersPlanksHome' && isVisible){
         this.countUpPlanks(this.getSustainabilityNumbers.planksUsed)
         this.numbersPlanksHome.activated = true
       }
       if(!this.numbersTreesHome.activated && element == 'numbersTreesHome' && isVisible){
         this.countUpTrees(this.getSustainabilityNumbers.treesPlanted)
         this.numbersTreesHome.activated = true
       }
       // if(!this.numbersPower.activated && element == 'numbersPower' && isVisible){
       //   this.countUpPower(this.getSustainabilityNumbers.electricityUsed)
       //   this.numbersPower.activated = true
       // }
     },
     countUpPlanks(final){
       if(this.numbersPlanksHome.counter < final) {
            setTimeout(() => {
                this.numbersPlanksHome.counter += Math.ceil((final-this.numbersPlanksHome.counter)/10)
                Math.round(this.numbersPlanksHome.counter)
                this.countUpPlanks(final)
            }, 40)
        }
     },
     countUpTrees(final){
       if(this.numbersTreesHome.counter < final) {
            setTimeout(() => {
                this.numbersTreesHome.counter += Math.ceil((final-this.numbersTreesHome.counter)/10)
                this.countUpTrees(final)
            }, 40)
        }
     },
     countUpPower(final){
       if(this.numbersPower.counter < final) {
            setTimeout(() => {
                this.numbersPower.counter += Math.ceil((final-this.numbersPower.counter)/10)
                this.countUpPower(final)
            }, 40)
        }
     },
   }
}
</script>

<style scoped>
  #homeDesktop > * {
    /* position: relative; */
    /* top: var(--desktopNavigationHeight); */
  }
  .cardWrapper{
    margin: 50px 0 0 0;
    width: 400px;
    height: 80px;
  }
  .card{
    position: relative;
    display: grid;
    grid-template-columns: 80px 1fr;
    padding: 27px 10px 15px 0;
  }
  .cardIntro{
    position: relative;
    display: grid;
    grid-template-columns: 80px 1fr;
    padding: 15px 10px 15px 0;
  }
  #homeDesktop{
    width: 100vw;
  }
  #A_intro{
    background-image: url('./../../public/img/gerüstbohlen-tisch-konfigurieren-d.jpeg');
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
    background-position: bottom center;
    min-height: 95vh;
    /* max-height: 105vh; */
    position: relative;
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  #banner{
    background-color: var(--accentColorShaded);
    height: 95px;
    width: 100%;
    position: relative;
  }
  #textBanner{
    position: absolute;
    bottom: 0px;
    width: 100%;
    text-align: center;
    color: var(--mainColor);
    margin: 0;
    font-size: 14px !important;
  }
  #B_material{
    min-height: 70vh;
    padding-bottom: 5vw;
  }
  #b_plankPictureView{
    /* margin-top: 90px; */
    height: 190px;
  }
  #b_recycletext{
    margin-top: 50px;
  }
  #C_tableConfigurator{
    /* height: calc(10vw); */
  }
  #D_sustainability{
    /* background-color: white; */
  }
  #E_benchConfigurator{
    background-color: white;
    min-height: 885px;
  }
  #F_about{
    padding-top: 40px;
  }
  #G_footer{
    position: relative;
    padding-top: 20px;
  }
  #logoView{
    height: calc(100vh - var(--desktopNavigationHeight) - 20vh);
    padding-top: 100px;
  }
  /* #introTextView{
    height: 400px;
  } */
  #introChips{
    height: 0px;
    position: relative;
    top: -250px;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }
  .introChip{
  width: 80%;
  max-width: 300px;
  margin: auto;
  text-align: left !important;
  }
  #introTextView{
    height: 400px;
    position: absolute;
    left: 0;
    top: 120px;
    text-align: left;
    padding-left: 20px;
  }
  #backgroundShade{
    padding: 50px 30px;
    height: 280px;
    background-color: #FFFFFFAA;
  }
  .slideELement{
    min-height: calc(100vh - var(--desktopNavigationHeight));
  }

  .slidePicture{
    height: calc(100vh - var(--desktopNavigationHeight));
  }

  /* .stickyAnimation{
    position:sticky;
    top: var(--desktopNavigationHeight);
  } */

  .inFromLeft{
    position: absolute;
    left: -100%;
    width: 100%;
  }
  .inFromRight{
    position: absolute;
    left: 100%;
    width: 100%;
  }
  .animationSlidein {
    animation: slidein 2s forwards;
  }
  .text{
    padding: 100px 15% 0 15%;
  }
  .bigLineHeight{
    display: inline-block;
    margin-bottom: 100px;
  }
  .mediumLineHeight{
    display: inline-block;
    margin-bottom: 40px;
  }

  @keyframes slidein {
    100% { left: 0; }
  }
  .slideGroup{
    width:100%;
    display: grid;
    grid-template-columns: 1fr 1050px 1fr;
  }

</style>
